export default __webpack_public_path__ + "static/media/akvaKul.d544fedb.pdf";